<template>
  <div
    v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('view_apartment')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="search.startTime"
                      @dp-change="onChangeStartTime(search.startTime)"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="endDateOptions"
                      v-model="search.endTime"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3" 
                v-if="tabSelect === apartmentTypeTabs.REVENUE_OF_ROOM_MONEY">
                <div class="form-group">
                  <v-select
                    class="clear"
                    :options="apartmentTypeList"
                    :reduce="data => data.value"
                    :getOptionLabel="option => $t(option.text)"
                    v-model="search.apartmentTypeId"
                    :placeholder="$t('apartmentType.title')"
                  >
                    <template v-slot:option="option">
                      {{ option.text }}
                    </template>
                  </v-select>
                </div>
              </div>
              
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="">
          <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li
                  class="active"
                  @click="onSelectTab(apartmentTypeTabs.INVOICE_REVENUE)"
                >
                  <a href="#tab1primary" data-toggle="tab">{{
                    $t("apartmentReceipt.invoiceRevenue")
                  }}</a>
                </li>
                <li @click="onSelectTab(apartmentTypeTabs.REVENUE_OF_ROOM_MONEY)">
                  <a href="#tab2primary" data-toggle="tab">{{
                    $t("apartmentReceipt.roomRevenue")
                  }}</a>
                </li>
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="tab1primary">
                  <!-- <apartment-type-list
                    ref="apartmentTypeList"
                  ></apartment-type-list> -->
                  <receipt-list ref="receiptList"/>
                </div>
                <div class="tab-pane fade" id="tab2primary">
                  <!-- <apartment-group ref="apartmentGroup"></apartment-group> -->
                  <apartment-receipt-list ref="apartmentReceiptList"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <!-- </div>
        </div> -->
        <!--  -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import LTEButton from "@/components/LTEButton.vue";
// import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
// import moment from "moment";
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import ReceiptList from "./ReceiptList";
import ApartmentReceiptList from "./ApartmentReceiptList";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from 'moment';

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker,
    ReceiptList,
    ApartmentReceiptList
  },
  data() {
    return {
      search: {
        searchText: null,
        startTime: null,
        endTime: null,
        apartmentTypeId: null
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      endDateOptions: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: moment()
      },
      isLoading: false,
      apartmentTypeTabs: Enum.ApartmentReceiptEnum,
      tabSelect: Enum.ApartmentReceiptEnum.INVOICE_REVENUE,
      apartmentTypeList: []
    };
  },
  watch: {
    GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA
      this.apartmentTypeList = []
      data.forEach(value => {
        let item = {
          value: value.id,
          text: value.name
        }
        this.apartmentTypeList.push(item)
      })
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectTab: function(value) {
      this.tabSelect = value;
      switch (value) {
        case 1:
          this.search.searchText = null
          this.$refs.receiptList.getSearchData(this.search);
          break;
        case 2:
          this.search.searchText = null
          this.search.apartmentTypeId = null
          this.$refs.apartmentReceiptList.getSearchData(this.search);
          break;
        default:
          break;
      }
    },
    onSearchCase: function() {
      if (this.tabSelect === Enum.ApartmentReceiptEnum.INVOICE_REVENUE) {
        this.$refs.receiptList.getSearchData(this.search);
      }
      if (this.tabSelect === Enum.ApartmentReceiptEnum.REVENUE_OF_ROOM_MONEY) {
        this.$refs.apartmentReceiptList.getSearchData(this.search);
      }
    },
    onChangeStartTime: function(data) {
      if (!utils.isEmptyString(data)) {
        this.endDateOptions.minDate = moment(data, "DD/MM/YYYY")
      }
      this.search.endTime = null
    },
    getApartmentTypeList: function() {
      this.isLoading = true;
      this.GET_APARTMENT_TYPE_LIST()
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_TYPE_LIST"
    ])
  },
  mounted() {
    this.getApartmentTypeList()
  }
};
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentReceipt/ApartmentReceiptTabs.vue